import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCloudDashboard } from '../../api/cloudApi';

export const fetchCloudDashboardData = createAsyncThunk(
  'cloudDashboard/fetchCloudDashboardData',
  async (_, { rejectWithValue }) => {
    try {
      // 後端以 project_uuid 作為唯一外部識別（API 層自動注入）
      const res = await fetchCloudDashboard({});
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message || 'Unknown error');
    }
  }
);

const initialState = {
  months: [],
  cloudPassedData: [],
  cloudHighRiskData: [],
  cloudMediumRiskData: [],
  cloudLowRiskData: [],
  riskAssessment: null,
  meta: null,
  loading: false,
  error: null,
};

const cloudDashboardSlice = createSlice({
  name: 'cloudDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCloudDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCloudDashboardData.fulfilled, (state, action) => {
        state.loading = false;

        // 你的後端回傳格式是：{ success: true, data: {...} }
        const payload = action.payload || {};
        const data = payload.data || {};

        state.months = data.months || [];
        state.cloudPassedData = data.cloudPassedData || [];
        state.cloudHighRiskData = data.cloudHighRiskData || [];
        state.cloudMediumRiskData = data.cloudMediumRiskData || [];
        state.cloudLowRiskData = data.cloudLowRiskData || [];
        state.riskAssessment = data.risk_assessment || null;
        state.meta = data.meta || null;
      })
      .addCase(fetchCloudDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Fetch failed';
      });
  },
});

export default cloudDashboardSlice.reducer;
